import { OxGristEditor } from './ox-grist-editor.js'
import { customElement } from 'lit/decorators.js'
import { html } from 'lit'

@customElement('ox-grist-editor-color')
export class OxGristEditorColor extends OxGristEditor {
  get editorTemplate() {
    return html` <input type="color" .value=${this.value} /> `
  }
}
